module.exports = require("C:\\Users\\katzy\\code\\my-portfolios\\web-portfolio\\src\\utils\\typography.js")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 358
// module chunks = 231608221292675